import { GenericValueLongText } from './../../common/model/genericvaluelongtext';
import { JobAdvertisementContactPerson } from './jobadvertisement-classes';

export class JobAdvertisement {
    readonly lockversion?: number;

    constructor(
        readonly id?: number,
        readonly jobJoinId?: number,
        readonly status?: number,
        readonly refNumber?: string,
        readonly vergabeDatum?: Date,
        readonly jobAdStatus?: string,
        readonly description?: string,
        readonly shortDescription?: string,
        readonly validFrom?: Date,
        readonly validTo?: Date,
        readonly firstContactPerson?: JobAdvertisementContactPerson,
        readonly secondContactPerson?: JobAdvertisementContactPerson,
        readonly jobAdvertisementCategory?: GenericValueLongText,
        readonly onlineApplicationPossible?: boolean,
        readonly sasTextFormat?: string,
        readonly jobAdvertisementDocumentAvailable?: boolean ) { }
}
